import { useSetState } from '@/shared/lib/customHooks';
import { useEffect } from 'react';

/**
 * Keeps the create return shipping page header aware of page scrolling. Holds an isScroll flag and registers a window scroll listener that flips it when the page leaves or returns to the top, removing the listener on cleanup.
 *
 * @returns Header state holding the isScroll flag.
 */
const useCreateReturnShippingHeader = () => {
  const [state, setState] = useSetState({
    isScroll: false,
  });

  useEffect(() => {
    /**
     * Marks the create return shipping header as scrolled so it can render its shadow. Flips the isScroll flag when window.scrollY moves off or back to zero.
     *
     * @returns Nothing.
     */
    const handleScroll = () => {
      if (window.scrollY === 0 && state.isScroll) {
        setState({ isScroll: false });
      } else if (window.scrollY !== 0 && !state.isScroll) {
        setState({ isScroll: true });
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [state.isScroll]);

  return { state };
};

export { useCreateReturnShippingHeader };
